// extracted by mini-css-extract-plugin
export default {"container":"login_container__P0FSm","form":"login_form__2L96z","link":"login_link__2qae1","wrapper":"login_wrapper__p-L8E","text":"login_text__I07yL"};